import { Chip } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { IssueTicketStatus } from 'src/graphql/generated/graphql';

export const StatusField = ({ status }: { status: IssueTicketStatus }) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'issue.ticket.form.fields.status-options',
  });

  const statusMap = {
    [IssueTicketStatus.Open]: t('open'),
    [IssueTicketStatus.InProgress]: t('in-progress'),
    [IssueTicketStatus.Blocked]: t('blocked'),
    [IssueTicketStatus.Resolved]: t('resolved'),
  };

  return <Chip label={statusMap[status]} />;
};
